import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import React from "react";

export function Form_Select(props) {
    const {item, localFormState, setLocalFormState} = props;

    const { inputSize = "normal", noneAllowed = true, allAllowed = false } = item;
    return (<>
        <FormControl
            className={"w-100"}
            sx={{minWidth: '100%'}}
            size={inputSize}
            helperText={item.helperText}
            required={ item.required || false }
        >
            <InputLabel shrink id="demo-simple-select-placeholder-label-label">
                {item.label}
            </InputLabel>
            <Select
                className={"w-100"}
                fullWidth
                autoWidth
                variant="outlined"
                label={item.label}
                labelId="demo-simple-select-placeholder-label-label"
                id="demo-simple-select-placeholder-label"
                // helperText={item.helperText}
                size={inputSize}

                value={(localFormState[item.key] === null || localFormState[item.key] === undefined) ? '' : localFormState[item.key]}
                onChange={
                    (e) => {
                        // submit new state to the upper system
                        setLocalFormState({
                            ...localFormState,
                            [item.key]: e.target.value
                        });
                    }
                }
                displayEmpty
            >
                {allAllowed && (
                    <MenuItem value="">
                        <em>All</em>
                    </MenuItem>
                )}
                {noneAllowed && (
                    <MenuItem value="">
                        <em>None</em>
                    </MenuItem>
                )}

                {item.options !== undefined && item.options.map((i) => {
                    return (
                        <MenuItem sx={{minWidth: '250px'}} key={i.value} value={i.value}>{i.label}</MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    </>);
}